const loader = require("../assets/gif/loader.gif");

export { loader };
